import { useEffect } from 'react';
import { useLocation } from 'react-router';

import usePrevious from './usePrevious';

export default function useScrollToTopOnRouteChange() {
  const { pathname } = useLocation();
  const previousPathName = usePrevious(pathname);

  useEffect(() => {
    if (previousPathName !== pathname) {
      window.scrollTo(0, 0);
    }
  }, [pathname, previousPathName]);
}
